
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/profiles/[slug]",
      function () {
        return require("private-next-pages/companies/profiles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/profiles/[slug]"])
      });
    }
  